import { FetchResult } from "@apollo/client";
import { toast } from "react-toastify";

export function myToastSave(
  saveResponse: Promise<FetchResult<any>>,
  pendingMessage?: string,
  successMessage?: string,
  onSave?: () => void,
) {
  toast.promise(
    saveResponse,
    {
      pending: {
        render() {
          return pendingMessage ? pendingMessage : "Saving...";
        },
        icon: false,
      },
      success: {
        render() {
          onSave?.();
          return successMessage ? successMessage : "Successfully saved!";
        },
      },
      error: {
        render({ data }: any) {
          return data?.message ?? "An error occurred";
        },
      },
    },
    {
      position: "bottom-center",
    },
  );
}

export function myToastError(errorMessage: string) {
  toast.error(errorMessage, { position: "bottom-center" });
}
